var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.icon,{tag:"component",class:_vm.classes})
}
var staticRenderFns = []

export { render, staticRenderFns }